// extracted by mini-css-extract-plugin
module.exports = {"person":"styles_person__25gAQ"};